

















































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { OpenDropdownLightPayload } from '@/core/sw-qsg';
import { namespace } from 'vuex-class';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
// import { GmsFtrMangementUsersStoreState, SetLoggedInUserQsgStatusPayload } from '@/modules/fw-svc-gms/gms-ftr-management-users';
// import { SetBlockViewportPayload } from '@/core';
// import { gmsApiService } from '@/shared/gms-api-service';
// import { ApiError } from '@libs-uuif/shared/api-service';

const cssPrefix = 'sw-guide-pagintaion';
const qsgNamespace = namespace('SwQsgStoreStateModule');
// const userManagementModule = namespace('GmsFtrMangementUsersStoreStateModule');

@Component({
  components: {
    SwIconButton,
  },
})
export default class SwQuickStartGuidePagination extends SwExtendedVue {
  cssPrefix = cssPrefix;
  activePage: number = 1;
  prevVisitedPage: number = 1;

  @Prop({ type: Number, required: true })
  currentPage: number;

  @Prop({ type: Number, required: true })
  totalPage: number;
  /*
  @userManagementModule.State
  readonly loggedInUserDetails: GmsFtrMangementUsersStoreState['loggedInUserDetails'];
  */
  @qsgNamespace.Mutation
  readonly openDropdownLight: VuexMappedMutation<OpenDropdownLightPayload>;
  /*
  @userManagementModule.Mutation
  readonly setLoggedInUserQsgStatus: VuexMappedMutation<SetLoggedInUserQsgStatusPayload>;

  @Mutation
  setBlockViewport: VuexMappedMutation<SetBlockViewportPayload>;
  */
  created() {
    this.activePage = this.currentPage;
  }

  get visiblePages() {
    let pageNo: number[] = [];
    if (this.totalPage > 4) {
      if ((this.totalPage - this.activePage) < 3) {
        pageNo = [(this.totalPage - 3), (this.totalPage - 2), (this.totalPage - 1)];
      } else {
        pageNo = [2, 3, 4];
      }
    } else {
      pageNo = Array.from({ length: 2 }, (v: any, k: number) => (k + 2)) // tslint:disable-line
      .filter((val: number) => {
        return (this.totalPage - val) > -1;
      });
    }
    if (this.activePage > 3 && ((this.totalPage - this.activePage) > 2)) {
      pageNo = Array.from({ length: 3 }, (v: any, k: number) => (this.activePage + k - 1)); // tslint:disable-line
    }
    return pageNo;
  }

  pageChangeHandle(pageNo : number) {
    if (pageNo === this.prevVisitedPage) {
      return;
    }
    this.prevVisitedPage = pageNo;
    this.activePage = Number(pageNo);
    this.$emit('loadPage', this.activePage); // tslint:disable-line
  }

  closeGuide() {
    // mutate the store for this.loggedInUserDetails (This store update is not needed, its handled by sivakumar, updating localstorage when api call is made)
    // this.setLoggedInUserQsgStatus({ flag: false });
    // PUT users/current  request payload: this.loggedInUserDetails;
    this.updateUserQsgStatus();
    setTimeout(() => {
      // eventBus.$emit('openDropdownLight', true);
      this.openDropdownLight({ flag: true });
    },         300);
    // eventBus.$emit('openQuickStartGuide', 'closeGuide');    // before closing the qsg open header dropdown & render a node, after 5 seconds close qsg
    this.$emit('openQuickStartGuide', 'closeGuide'); // tslint:disable-line
  }

  closeOverlay() {
    // this.$emit('close-overlay');
    setTimeout(() => {
      // eventBus.$emit('openDropdownLight', true);
      this.openDropdownLight({ flag: true });
    },         300);
    // eventBus.$emit('openQuickStartGuide', 'closeGuide');    // before closing the qsg open header dropdown & render a node, after 5 seconds close qsg
    this.$emit('openQuickStartGuide', 'closeGuide'); // tslint:disable-line
  }

  /*
  tenants: obj.tenants ? obj.tenants
            : obj.role_tenant && obj.role_tenant.length > 0 ? obj.role_tenant.map((tenant:any) => { return tenant.tenant_id ? tenant.tenant_id : ''; })
            : [],
  */

  updateUserQsgStatus() {
    const params = {
      highlighterNeeded : 'NO',
      mode : 'ISCLOUDINSIGHTQSG',
    };
    this.$store.dispatch('SwQsgStoreStateModule/postDisableQsg', params)
    .then((result) => { // tslint:disable-line
      this.$store.commit('stopLoading');
      if (result.msgCode === 'MSWAPP:SUCCESS') {
        // messageService.messageManager.showMessage('top-message', `${fwUtilService.apiUtils.parseResponseMessage(response)}`, 'success');
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: result.msgDesc });
        localStorage.setItem('isInsightsQSG', 'NO');
      } else {
        // fwUtilService.apiUtils.showMessageService(response);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: result.msgDesc });
      }
    })
    .catch(() => {
      this.$store.commit('stopLoading');
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Error' });
    });
  }
}
